import { Card } from 'reactstrap';
import SearchControls from './parts/SearchControls';
import ClassroomsTable from './parts/ClassroomsTable';
import { ClassroomsLoader } from './parts/Loaders/ClassroomsLoader';
import ClassroomOptionsLoader from './parts/Loaders/ClassroomOptionsLoader';
import { SearchControlsLoader } from './parts/SearchControlsLoader';

export default function Classrooms() {
  return (
    <ClassroomsLoader>
      <SearchControlsLoader>
        <ClassroomOptionsLoader>
          <Card className="mx-3 p-4">
            <SearchControls />
            <ClassroomsTable />
          </Card>
        </ClassroomOptionsLoader>
      </SearchControlsLoader>
    </ClassroomsLoader>
  );
}
